@if (profileField$ | async; as profileField) {
  <dt class="sh-description-list__term">{{ typeTranslations.get('Defined') }}</dt>
  <dd class="sh-description-list__details">
    <svg sh-icon [name]="definedIcon$ | async" [size]="'small'" aria-hidden="true" class="sh-label-list__item__icon"></svg>
  </dd>
  @if (isRetentionPeriodSet$ | async) {
    <dt class="sh-description-list__term">{{ typeTranslations.get('Term') }}</dt>
    <dd class="sh-description-list__details">{{ value$ | async }}</dd>
    <dt class="sh-description-list__term">{{ typeTranslations.get('Specification') }}</dt>
    <dd class="sh-description-list__details">{{ specification$ | async }}</dd>
    <dt class="sh-description-list__term">{{ typeTranslations.get('Info') }}</dt>
    <dd class="sh-description-list__details sh-wrap-text sh-preserve-linebreaks">{{ info$ | async }}</dd>
    <dt class="sh-description-list__term">{{ typeTranslations.get('Motivation') }}</dt>
    <dd class="sh-description-list__details sh-wrap-text sh-preserve-linebreaks">{{ motivation$ | async }}</dd>
  }
}
